import React from 'react';
import { FaArrowAltCircleRight } from "react-icons/fa";
import { Link as RouterLink } from "react-router-dom";

const OccasionalCard = ({ data }) => {
  return (
    <div className="w-full max-w-xs shadow-lg rounded-3xl p-4 flex flex-col items-center justify-center gap-4 transition-all hover:-translate-y-1 hover:shadow-2xl" style={{
      background: "linear-gradient(to bottom right, #5C5CFF, #000080)",
    }}>
      <div className="rounded-2xl overflow-hidden w-full">
        <img
          src={data.image}
          alt={data.name}
          loading="lazy"
          className="object-cover w-full"
        />
      </div>

      <div className="hidden md:flex flex-col items-center justify-center text-center">
        <h1 className="sm:text-[16px] sm:font-[500] md:text-[20px] md:font-[600] text-white">{data.name}</h1>
      </div>

      <RouterLink to={`/product?styles=${data._id}`} className="block w-full">
        <div className="px-2 py-2 md:px-7 bg-white shadow-md rounded-xl flex items-center justify-center gap-2 cursor-pointer group hover:bg-[#000080] hover:text-white border border-white hover:border-[#FFDB58] transition-all duration-300 ease-in-out">
          <p className="hidden md:block text-[18px] font-[600] text-[#000080] group-hover:text-white">Explore</p>
          <p className="md:hidden text-[11px] font-[600] text-[#000080] group-hover:text-white uppercase">{data.name}</p>
          <FaArrowAltCircleRight className="text-[25px] text-[#000080] group-hover:text-[#FFDB58]" />
        </div>
      </RouterLink>
    </div>
  );
};

export default OccasionalCard;
